import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import PdfRenderWidgets from '../../pdfWidgets/PdfRenderWidgets'
import PreApprovedProjectForm from '../preApprovedProject/PreApprovedProjectForm'
import TableReport from '../tableReport/TableReport'
import {
  searchProjectalreadyapprovelist,
  downloadProjectalreadyapprovelist,
} from '../../../redux/actions/adminReport'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'

export default function ApprovedProjectWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isSucceed, setIsSucceed] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})
  const [dataTable, setDataTable] = useState()
  const [loading, setloading] = useState(false)
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(25)
  const [clearValue, setClearValue] = useState(false)

  useEffect(() => {
    //setDataTable(mockCallData)
  }, [])

  const onSubmit = (data) => {
    console.log('onPreview', data)

    let request = {
      fromBugetYear: data.fromBudgetYear,
      toBugetYear: data.toBudgetYear,
      status: data.projectStatusOption,
      fromDate: data.preApprovedProjectStartDate,
      toDate: data.preApprovedProjectEndDate,
      showAddress: data.displayAddress,
      projectStartDate: data.projectStartDate || null,
      projectEndDate: data.projectEndDate || null,
      departmentCode: data.projectDepartment,
      pageNumber: 1,
      pageSize: pagSize,
    }

    setCondition(data)
    handlePreviewReport(request)
  }

  const handleSubmitOnPrint = (data) => {
    console.log('handleSubmitOnPrint ', data)

    let request = {
      fromBugetYear: data.fromBudgetYear,
      toBugetYear: data.toBudgetYear,
      status: data.projectStatusOption,
      fromDate: data.preApprovedProjectStartDate,
      toDate: data.preApprovedProjectEndDate,
      showAddress: data.displayAddress,
      projectStartDate: data.projectStartDate || null,
      projectEndDate: data.projectEndDate || null,
      departmentCode: data.projectDepartment,
      // pageNumber: 1,
      // pageSize: pagSize,
    }

    setCondition(data)
    handleDownloadReport(request)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    console.log('handelGetSchemaOnReload ', condition, pagesize, pagenumber)

    let request = {
      fromBugetYear: condition.fromBudgetYear,
      toBugetYear: condition.toBudgetYear,
      status: condition.projectStatusOption,
      fromDate: condition.preApprovedProjectStartDate,
      toDate: condition.preApprovedProjectEndDate,
      showAddress: condition.displayAddress,
      projectStartDate: condition.projectStartDate || null,
      projectEndDate: condition.projectEndDate || null,
      departmentCode: condition.projectDepartment || '',
      pageNumber: pagenumber,
      pageSize: pagesize,
    }

    setPagSize(pagesize)
    handlePreviewReport(request)
  }

  const handlePreviewReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await searchProjectalreadyapprovelist(request)
      console.log('response', response.model.tableColumns)

      if (response.model) {
        const arrLength = response.model.tableColumns.length
        if (response.model.tableColumns[arrLength - 1].dataKey === 'rowNumber') {
          response.model.tableColumns.reverse()
        }

        setDataTable(response.model)
      } else {
        handelSetErrorMsg('error', 'ไม่สามารถแสดงข้อมูลได้')
      }
    } catch (e) {
      setIsError(true)
      handelSetErrorMsg('error', e.response.data.errors?.message || 'ไม่สามารถแสดงข้อมูลได้')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await downloadProjectalreadyapprovelist(request)

      console.log('response', file)
      if (file) {
        downloadFile(file, file.name || `รายงาน${formSchema.reportName}`)
      } else {
        handelSetErrorMsg('error', 'ไม่สามารถแสดงข้อมูลได้')
      }
    } catch (e) {
      let errorJson = JSON.parse(await e.response.data.text())
      setIsError(true)
      handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      setValue(key, null)
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <>
            <PreApprovedProjectForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              // handelPreview={onSubmit}
              clearValue={clearValue}
            />

            <hr />

            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}

            <ButtonPanelWidget
              isEdit={true}
              isError={isError}
              buttonText={formSchema.buttonText}
              onPreview={handleSubmit(onSubmit)}
              onPrint={handleSubmit(handleSubmitOnPrint)}
              onCancel={(el) => {
                setDataTable(null)
                setValueNullField()
                // setIsError(false)
                // location.reload()
              }}
            />
          </>
        )}
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <TableReport
          schema={dataTable}
          headerHeightSize={80}
          Controller={Controller}
          control={control}
          pagination={true}
          loading={isLoading}
          onReload={handelGetSchemaOnReload}
        />
      )}
    </>
  )
}
